import { createFileRoute } from "@tanstack/react-router";
import DiffCheckerPage from "@/pages/DiffCheckerPage";

export const Route = createFileRoute("/tools/diff-checker")({
  component: DiffCheckerPage,
});
